import { setPermission } from "@/features/userSlice";
import { getBaseUrl } from "@/helpers/fetch.helpers";
import fetchWrapper from "@/helpers/fetchWrapper";
import logger from "@/helpers/logger";
import { store } from "@/store";
import type { UserPermissions } from "@/types/data";

/**
 * A partial application that fetches permissions
 * for a service from its user endpoint
 * and adds it to the store.
 *
 * @param endpoint  url for the service
 * @param path  route path
 */
export const getUserPermissions = (endpoint: string, path: string) => {
  return async () => {
    const state = store.getState();
    const { userAppPermissions } = state.user;

    //if user permission for page is already stored then use that
    if (userAppPermissions[path]) {
      return userAppPermissions[path];
    }
    const userServiceUrl = getBaseUrl(endpoint);
    try {
      // Wait for the fetch to complete
      const res = await fetchWrapper<UserPermissions>(userServiceUrl);

      // Dispatch the result to the store
      store.dispatch(
        setPermission({
          page: path,
          userPermissions: res,
        })
      );

      // Return the fetched permissions
      return res;
    } catch (httpError) {
      logger.log("Issue while fetching user permission: ", httpError);

      // Return an empty permission
      return { hasControl: false, roles: [] } as UserPermissions;
    }
  };
};
